import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { MenuCard } from "@/components/MenuCard";
import { TablePicker } from "@/components/TablePicker";
import { OutletPicker } from "@/components/OutletPicker";
import { Skeleton } from "@/components/ui/skeleton";
import { CATEGORIES } from "@/lib/api";

export const MenuSection = ({ menu, loading }) => {
  const [cat, setCat] = useState("semua");
  const [q, setQ] = useState("");

  const shown = useMemo(
    () => {
      const list = menu.filter((m) => (cat === "semua" || cat === "terlaris" || m.category === cat) && m.name.toLowerCase().includes(q.toLowerCase().trim()));
      return cat === "terlaris" ? [...list].sort((a, b) => b.sold - a.sold) : list;
    },
    [menu, cat, q]
  );

  const cats = useMemo(() => CATEGORIES.slice(1).filter((c) => c.id !== "paket" || menu.some((m) => m.category === "paket")), [menu]);
  const byCat = useMemo(() => {
    const out = {};
    menu.forEach((m) => { (out[m.category] = out[m.category] || []).push(m); });
    return out;
  }, [menu]);

  return (
    <section id="menu" className="scroll-mt-24 min-w-0" data-testid="menu-section">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h2 className="font-serif font-semibold text-3xl sm:text-4xl tracking-tight text-ink">Mau pesan apa hari ini?</h2>
        <div className="flex flex-wrap gap-2"><OutletPicker /><TablePicker /></div>
      </div>
      <div className="flex flex-col md:flex-row md:items-center gap-3 mt-6">
        <label className="relative md:w-64 shrink-0">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted2" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari menu favorit..." data-testid="menu-search-input"
            className="w-full pl-9 pr-3 py-2.5 rounded-xl bg-paper border border-sage-200 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30" />
        </label>
        <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
          {[CATEGORIES[0], { id: "terlaris", label: "Terlaris" }, ...cats].map((c) => (
            <button key={c.id} onClick={() => setCat(c.id)} data-testid={`category-tab-${c.id === "semua" ? "all" : c.id}`}
              className={`pill whitespace-nowrap ${cat === c.id ? "bg-forest text-paper" : "bg-sage-100 text-ink/80 hover:bg-sage-200"}`}>
              {c.label}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-2 xl:grid-cols-3 gap-2 sm:gap-5 mt-6" data-testid="menu-grid">
        {loading && [1, 2, 3, 4].map((i) => <Skeleton key={i} className="h-72 rounded-2xl bg-sage-100" />)}
        {!loading && shown.map((m) => <MenuCard key={m.id} item={m} siblings={byCat[m.category]} menu={menu} />)}
      </div>
      {!loading && shown.length === 0 && (
        <p className="text-center text-muted2 py-16" data-testid="menu-empty">Menu tidak ditemukan. Coba kata kunci lain.</p>
      )}
    </section>
  );
};
